import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var TitleBarDefinition = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  width: 100%;\n  justify-content: space-between;\n  text-transform: uppercase;\n"])));
TitleBarDefinition.displayName = "TitleBar";
var TitleBar = TitleBarDefinition;
var TitleActionDefinition = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"])));
TitleActionDefinition.displayName = "TitleAction";
var TitleAction = TitleActionDefinition;
var TitleContentDefinition = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
TitleContentDefinition.displayName = "TitleContent";
var TitleContent = TitleContentDefinition;
var SideDefinition = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  ", ";\n  flex-direction: ", ";\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media (max-width: 1199px) {\n    flex: 1;\n    flex-basis: 100%;\n  }\n"])), function (props) {
  return props.basis && "flex-basis: ".concat(props.basis, "%");
}, function (props) {
  return props.vertical && "column" || "row";
});
SideDefinition.displayName = "Side";
SideDefinition.propTypes = {
  basis: PropTypes.number,
  vertical: PropTypes.bool
};
var Side = SideDefinition;
var PanelContentDefinition = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: ", ";\n  position: relative;\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  background-color: #fff;\n  min-width: 375px;\n"])), function (props) {
  return props.vertical && "column" || "row";
});
PanelContentDefinition.displayName = "PanelContent";
PanelContentDefinition.propTypes = {
  vertical: PropTypes.bool
};
var PanelContent = PanelContentDefinition;
var PanelDefinition = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  flex-direction: ", ";\n  position: relative;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  width: 100%;\n  height: ", ";\n  box-shadow: 0 5px 10px 0 rgba(0, 35, 75, 0.15);\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding: ", ";\n"])), function (props) {
  return props.basis && "flex-basis: ".concat(props.basis, "%");
}, function (props) {
  return props.vertical && "column" || "row";
}, function (props) {
  return props.h && "".concat(props.h, "px") || "auto";
}, function (props) {
  return "".concat(props.noPadding ? 0 : "30px");
});
PanelDefinition.displayName = "Panel";
PanelDefinition.propTypes = {
  basis: PropTypes.number,
  h: PropTypes.number,
  noPadding: PropTypes.bool,
  vertical: PropTypes.bool
};
var Panel = PanelDefinition;

export { Panel, PanelContent, Side, TitleAction, TitleBar, TitleContent };
